import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-buttons-action',
  templateUrl: './buttons-action.component.html',
  styleUrls: ['./buttons-action.component.scss'],
  standalone: false,
})
export class ButtonsActionComponent implements OnInit {

  @Input("message") message: string = '';
  @Input("messages") messages: Array<string> = [];
  @Input("isShowMessage") isShowMessage: boolean = false;
  @Input("isShowMessages") isShowMessages: boolean = false;
  @Input("styleMessage") styleMessage: string = 'color: #D32F2F';

  constructor() { }

  ngOnInit(): void {
  }

}
